import { api } from "boot/axios";

export default () => {
  //LevelAlert Indicators Datewise
  const LevelAlertIndicatorsDatewise = async (date) => {
    try {
      const data = await api.get(`/data/level-alert/?date=${date}`);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //LevelAlert Indicators Hourly Datewise
  const LevelAlertIndicatorsHourlyDatewise = async (date) => {
    try {
      const data = await api.get(`/data/level-alert/hourly/?date=${date}`);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //LevelAlert Indicators Weekly Datewise
  const LevelAlertIndicatorsWeeklyDatewise = async (date) => {
    try {
      const data = await api.get(`/data/level-alert/weekly/?date=${date}`);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //LevelAlert Indicators Symbolwise
  const LevelAlertIndicatorsSymbolwise = async (symbol) => {
    try {
      const data = await api.get(`/data/level-alert/?symbol=${symbol}`);
      return data;
      s;
    } catch (error) {
      throw new Error(error);
    }
  };

  //LevelAlert Indicators Hourly Symbolwise
  const LevelAlertIndicatorsHourlySymbolwise = async (symbol) => {
    try {
      const data = await api.get(`/data/level-alert/hourly/?symbol=${symbol}`);
      return data;
      s;
    } catch (error) {
      throw new Error(error);
    }
  };

  //LevelAlert Indicators Weekly Symbolwise
  const LevelAlertIndicatorsWeeklySymbolwise = async (symbol) => {
    try {
      const data = await api.get(`/data/level-alert/weekly/?symbol=${symbol}`);
      return data;
      s;
    } catch (error) {
      throw new Error(error);
    }
  };

  return {
    LevelAlertIndicatorsDatewise,
    LevelAlertIndicatorsWeeklyDatewise,
    LevelAlertIndicatorsHourlyDatewise,

    LevelAlertIndicatorsSymbolwise,
    LevelAlertIndicatorsWeeklySymbolwise,
    LevelAlertIndicatorsHourlySymbolwise,
  };
};
